export const LANG = {
   sv: {
      roledescription: { slideshow: 'karusell', slide: 'bild' },
      prev: 'Visa föregående',
      next: 'Visa nästa',
      pause: 'Stoppa',
      play: 'Starta',
      slideshow: 'automatisk bläddring',
      zoom: 'Visa',
      largeImage: 'stor bild',
      close: 'Stäng',
      download: 'Ladda ner bild',
      image: 'Bild',
      of: 'av',
   },
   en: {
      roledescription: { slideshow: 'carousel', slide: 'image' },
      prev: 'Previous',
      next: 'Next',
      pause: 'Stop',
      play: 'Start',
      slideshow: 'automatic slide show',
      zoom: 'Show',
      largeImage: 'large image',
      close: 'Close',
      download: 'Download image',
      image: 'Image',
      of: 'of',
   },
   no: {
      roledescription: { slideshow: 'karusell', slide: 'bilde' },
      prev: 'Forrige',
      next: 'Neste',
      pause: 'Stopp',
      play: 'Start',
      slideshow: 'automatisk lysbildeserie',
      zoom: 'Vis',
      largeImage: 'stort bilde',
      close: 'Lukk',
      download: 'Last ned bilde',
      image: 'Bilde',
      of: 'av',
   },
};
